module.exports = __webpack_public_path__ + "img/favicon.67cf3ec8.png";